import { AppConfigService } from '@foundation/app/config';
import { LayoutService } from '@foundation/app/layout';
import { Injectable, inject, signal } from '@angular/core';
import { findCampusByPromotion, GadzartsCampus } from '../gadzarts-campuses.model';
import { extractPromsSubdomain } from './proms-cname.util';

const THEME_STORAGE_KEY = 'app_theme_light';

/**
 * Detects a "proms" subdomain (e.g. an211.gadz.app) and applies that
 * campus's traditional theme as the default — but only the first time,
 * i.e. only when the visitor has no saved theme preference yet. Once
 * someone has a preference (from an earlier visit or a manual pick),
 * we don't silently override it just because they land on a different
 * proms's subdomain.
 */
@Injectable({ providedIn: 'root' })
export class PromsCnameService {
	private _appConfig = inject(AppConfigService);
	private _layoutService = inject(LayoutService);

	public readonly promotion = signal<string | null>(null);
	public readonly campus = signal<GadzartsCampus | null>(null);

	constructor() {
		const baseDomain: string | undefined = this._appConfig.config$_.environment?.baseDomain;
		if (!baseDomain) return;

		const promotion = extractPromsSubdomain(window.location.hostname, baseDomain);
		if (!promotion) return;

		const campus = findCampusByPromotion(promotion);
		if (!campus) return;

		this.promotion.set(promotion);
		this.campus.set(campus);

		const hasSavedThemePreference = localStorage.getItem(THEME_STORAGE_KEY) !== null;
		if (!hasSavedThemePreference) {
			this._layoutService.updateLightTheme(campus.theme);
		}
	}
}
